var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

export { invariant as default };



//////////////////
// WEBPACK FOOTER
// ./~/tiny-invariant/dist/tiny-invariant.esm.js
// module id = 629
// module chunks = 0